export default {
    "app_title": "スマート舗装管理システム",
    "profile": "プロフィール",
    "logout": "ログアウト",
    "user_login": "ユーザーログイン",
    "user_id": "ユーザーID",
    "user_password": "パスワード",
    "login": "ログインする",
    "dashboard": "ダッシュボード",
    "gis": "GIS",
    "road_surveyed_list": "道路調査リスト",
    "road_information_list": "道路情報リスト",
    "dashboard_total_length": "全長（非常に悪い）",
    "dashboard_mean_pavement_distress": "平均舗装の苦痛％",
    "dashboard_pavement_distress_map": "舗装遭難マップ",
    "dashboard_pavement_distress_distribution": "舗装の苦痛の分布",
    "no_data": "データーがない",
    "date": "日付",
    "user": "ユーザー",
    "clear_filter": "フィルターをクリア",
    "has_data": "データあり",
    "invalid_date": "無効な日付",
    "show": "公演",
    "hide": "隠す",
    "attributes": "属性",
    "deterioration_rank": "劣化ランク",
    // TODO アスファルト・コンクリ対応 START STEP2に含めない場合削除
    road_surface_type: "舗装の状態（種類）",
    // TODO アスファルト・コンクリ対応 END STEP2に含めない場合削除
    "road_uploader": "ロードアップローダー",
    "label_data": "データ",
    "label_images": "画像",
    "tooltip_select_csv_file": "csvファイルを選択します",
    "tooltip_select_folder_image": "画像フォルダを選択します",
    "upload": "アップロードする",
    "list_images": "リスト画像",
    "label_upload_surveyed": "調査済みのアップロード",
    "label_upload_surveyed_placeholder": "* .csvファイルをアップロード",
    "label_upload_road_info": "道路情報をアップロードする",
    "label_upload_road_info_placeholder": "* geo.jsonファイルをアップロードします",
    "table_title_filename": "ファイル名",
    "table_title_owner": "オーナー",
    "table_title_created_date": "作成日",
    "table_title_created_number_point": "ポイント数",
    "table_title_type": "タイプ",
    "table_title_number_road": "道路の数",
    "label_geo_file": "ジオファイル",
    "label_surveyed_file": "調査したファイル",
    // TODO: 日本語対応 チケット186
    "edit": "編集",
    "summary_tab": "サマリー",
    "filter_tab": "フィルター",
    "average_score": "平均スコア",
    "under4_score": "Miles are rated 4 or worse",
    "under3_score": "Miles are rated 3",
    "rating_distribution": "Rating Distribution",
    "deterioration_curve": "Deterioration Curve",
    "deterioration_curve_list": "Deterioration Curve List",
    "format_csv_download": "Format CSV DL",
    "delete_confirm_message": "Are you sure to delete No.{{id}}?",
    "attention": "The average scores might be biased due to the following reasons:<br/>- The results may include both actual and predicted scores.<br/>- The total mileage may significantly differ over the years depending on survey schedules.<br/>Please refer to the GIS view for further details on each year.<br/>",
    "deterioration_curve_upload_error_message": "Upload Failed: The Condition Index (SPM-PCI or SPM-PASER) Does NOT Match the Previous Survey Data.",
  }